module.exports = __webpack_public_path__ + "static/img/huanbanguanli1.246193dc.svg";